import Link from 'next/link'
import { useMemo } from 'react'
import styled from 'styled-components'
import { MyImage } from '~/components/ui/MyImage'
import { FenToYuan } from '~/utils'
import { getCollectionDetail_marketingModule_collection } from '~/graphqls/types'

const StyledMysteryBoxProduct = styled.div`
  margin-bottom: 32px;
  .product-thumb-wrap {
    position: relative;
    height: 300px;
    margin-bottom: 16px;
    border-radius: 16px;
    overflow: hidden;
    display: block;
    &:hover {
      .product-thumb {
        transform: scale(1.1);
        transition: all ease-in-out 180ms;
      }
    }
  }
  .product-thumb {
    height: 100%;
    width: 100%;
    transition: all ease-in-out 180ms;
  }
  .product-title {
    display: block;
    font-size: 14px;
    line-height: 24px;
    color: ${props => props.theme.dark2};
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    transition: all 0.3s ease;
    &:hover {
      transition: all 0.3s ease;
      color: ${props => props.theme.primaryColor};
    }
  }
  .product-price {
    font-size: 12px;
    line-height: 20px;
    color: ${props => props.theme.dark2};
  }
`

export const MySteryBoxProduct: React.FC<{
  data: getCollectionDetail_marketingModule_collection
}> = ({ data }) => {
  const jumpUrl = useMemo(() => {
    return `/mystery-box/${data.activity?.id}`
  }, [data])

  return (
    <StyledMysteryBoxProduct>
      <Link href={jumpUrl}>
        <a className="product-thumb-wrap">
          <MyImage
            tag="v800"
            className="product-thumb"
            src={data?.activity?.url}
          />
        </a>
      </Link>
      <Link href={jumpUrl}>
        <a className="product-title">{data.name}</a>
      </Link>
      <div className="product-price">¥{FenToYuan(data?.buy?.price)}</div>
    </StyledMysteryBoxProduct>
  )
}
